import { Divider, Paper } from "@mui/material";
import { IDynamicTableProps } from "src/types/organisms";
import DataTable from "@components/molecules/DataTable/DataTable";
import TitlePaper from "@components/atoms/TitlePaper/TitlePaper";
const DynamicTable = ({
  title,
  subtitle = "",
  headers,
  rows,
  pages,
  isLoading = false,
  onChangePage,
  emptyMessage = "Sin elementos encontrados",
  topRender,
  bottomRender
}: IDynamicTableProps) => {
  const classes = {
    root: {
      marginTop: 4,
      padding: "24px",
      width: 1,
      position: "relative"
    }
  };
  return <Paper elevation={12} sx={classes.root}>
      <TitlePaper title={title} subtitle={subtitle} />
      <br />
      {topRender}
      <Divider />
      <DataTable isLoading={isLoading} headers={headers} rows={rows} pages={pages} onChangePage={onChangePage} emptyMessage={emptyMessage} bottomRender={bottomRender} />
    </Paper>;
};
export default DynamicTable;